import type { NextPage, GetServerSideProps } from 'next'
import Link from 'next/link'
import { useRouter } from 'next/router'

import SEO from '@/modules/seo'
import Model from '@/modules/board'
import type { Item } from '@/modules/board'

import Page from '@/components/pages/board/item'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const availableCategories = ['notice', 'document'];
  const boardCategory = context.query.category as string || '';
  const idx = parseInt(context.query.idx as string, 10);

  const model = new Model();
  model.category = boardCategory;
  const boardTitle = model.getTitle();
  const result = await model.getItem({ idx });

  if (!availableCategories.includes(boardCategory) || !result.item || !result.item.idx) {
    context.res.statusCode = 404
    return {
      notFound: true,
      redirect: {
        destination: "/",
        permanent: 404,
      },
    };
  }

  return {
    props: {
      boardTitle,
      boardCategory,
      item: result.item
    }
  }
}


interface IProps {
  boardTitle: string;
  boardCategory: string;
  query: string;
  item: Item;
}

const Component: NextPage<IProps> = (props) => {
  const pageTitle = `${props.boardTitle}`

  return (
    <div className='flex flex-col justify-center'>
      <SEO title={pageTitle} />
      <Page {...props} />
    </div>
  )
}

export default Component
